export const LISTING_REPORT_CATEGORIES = [
  { value: "vehicle_unavailable", label: "Vehículo ya no disponible" },
  { value: "incorrect_price", label: "Precio incorrecto" },
  { value: "incorrect_information", label: "Información incorrecta" },
  { value: "misleading_photos", label: "Fotos incorrectas o engañosas" },
  { value: "suspicious_mileage", label: "Kilometraje sospechoso" },
  { value: "dealer_no_response", label: "Dealer no responde" },
  { value: "off_platform_payment_request", label: "Me pidieron dinero por fuera" },
  { value: "fraud_suspicion", label: "Sospecha de fraude" },
  { value: "other", label: "Otro" },
];

export const DEALER_REPORT_CATEGORIES = [
  { value: "dealer_no_response", label: "No responde" },
  { value: "wrong_contact_info", label: "Información de contacto incorrecta" },
  { value: "wrong_address", label: "Dirección incorrecta" },
  { value: "stale_inventory", label: "Inventario desactualizado" },
  { value: "bad_contact_experience", label: "Mala experiencia de contacto" },
  { value: "fraud_suspicion", label: "Sospecha de fraude" },
  { value: "inappropriate_behavior", label: "Comportamiento inapropiado" },
  { value: "other", label: "Otro" },
];

export const CATEGORY_LABELS = Object.fromEntries([
  ...LISTING_REPORT_CATEGORIES,
  ...DEALER_REPORT_CATEGORIES,
].map((c) => [c.value, c.label]));

export const SEVERITY_LABELS = { low: "Bajo", medium: "Medio", high: "Alto", critical: "Crítico" };
export const SEVERITY_CLASS = {
  low: "admin-badge--info",
  medium: "admin-badge--warning",
  high: "admin-badge--warning",
  critical: "admin-badge--danger",
};

export const CASE_STATUS_LABELS = {
  open: "Abierto",
  investigating: "Investigando",
  waiting_on_dealer: "Esperando dealer",
  waiting_on_buyer: "Esperando comprador",
  action_taken: "Acción tomada",
  resolved: "Resuelto",
  dismissed: "Descartado",
  escalated: "Escalado",
  archived: "Archivado",
};

export const CASE_TYPE_LABELS = {
  listing_accuracy: "Precisión listing",
  dealer_behavior: "Comportamiento dealer",
  fraud_risk: "Riesgo fraude",
  stale_inventory: "Inventario obsoleto",
  contact_issue: "Contacto",
  duplicate_listing: "Duplicado",
  suspicious_listing: "Listing sospechoso",
  buyer_complaint: "Queja comprador",
  other: "Otro",
};

export const RESOLUTION_LABELS = {
  corrected_listing: "Listing corregido",
  paused_listing: "Listing pausado",
  removed_listing: "Listing removido",
  dealer_contacted: "Dealer contactado",
  dealer_warned: "Dealer advertido",
  dealer_suspended: "Dealer suspendido",
  no_issue_found: "Sin problema",
  duplicate_report: "Reporte duplicado",
  buyer_unreachable: "Comprador no localizable",
  escalated_internal: "Escalado interno",
  other: "Otro",
};

export const SAFETY_DISCLAIMER =
  "AutoMapa organiza información y señales de confianza, pero no reemplaza la revisión legal, documental o mecánica antes de comprar.";

export const REPORT_SUCCESS_COPY =
  "Gracias por ayudarnos a mantener AutoMapa confiable. Revisaremos tu reporte.";

export function trackTrustSafetyEvent(eventType, metadata = {}) {
  if (process.env.NODE_ENV === "development") {
    // eslint-disable-next-line no-console
    console.debug("[trust-safety-event]", eventType, metadata);
  }
}
